<script setup lang="ts">
// Props
defineProps<{
  firstname?: string;
  lastname?: string;
  photoUrl?: string;
}>();
</script>
<template>
  <img v-if="photoUrl" class="bg-primary w-6 h-6 rounded-full object-cover" :src="photoUrl" />
  <div v-else-if="firstname && lastname" class="bg-blue-500 w-6 h-6 rounded-full text-white flex items-center justify-center text-xs">
    {{ `${firstname[0]}${lastname[0]}` }}
  </div>
</template>
